import { render, staticRenderFns } from "./TipsFilter.vue?vue&type=template&id=cf4f4adc&scoped=true&"
import script from "./TipsFilter.vue?vue&type=script&lang=js&"
export * from "./TipsFilter.vue?vue&type=script&lang=js&"
import style0 from "./TipsFilter.vue?vue&type=style&index=0&id=cf4f4adc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf4f4adc",
  null
  
)

export default component.exports